import React from 'react';
import { Link } from 'react-router-dom';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg'
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'
import AppVars from '../../../../AppVars.js'

const appVars = AppVars.getInstance()

class EmbeddedEmailVerificationView extends React.Component{
    constructor(props){
        super(props);
        this.state ={

        }
    }

    render(){
        return (
            <div>
            <div className = "justify-content-center line-box">
                <div role = "banner">
                    <Row className = "">
                    <Link to = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></Link>
                    </Row>
                </div>
                <div role = "main">
                    <Row className = "justify-content-center location">
                        <div>Registration</div>
                    </Row>
                    <div className = {`${this.props.activationEmailSent !== true ? "block" : "none"}`}>
                    <Row className = "title__TO left">
                        Activate Your Account
                    </Row>
                    <Row className = "justify-content-center message__TO left">
                        <p>Click below to resend your activation <br className = "mobile-br" /> email to <br className = "desktop-br" /><b>{this.props.email}</b>. </p>
                    </Row>
                    <div style = {{'display' : 'grid', 'grid-template-rows' : 'auto', 'grid-template-columns' : '210px', 'margin' : 'auto'}}>
                    <Button data-testid = "EmbeddedResendButton" bsPrefix = "button-left button__TO" type = "submit" onClick={this.props.handleEmbeddedActivation}>Resend Activation Email</Button>
                    </div>
                    </div>
                    <div className = {`${this.props.activationEmailSent === true ? "block" : "none"}`}>
                    <Row className = "title__TO left">
                        We Sent You An Email
                    </Row>
                    <Row className = "justify-content-center message__TO left">
                    <div className="subTitle__TO left" >{this.props.email}</div>
                    </Row>
                    <Row className = "justify-content-center message__TO left">
                        <p>Click the link in the email to complete your registration. The link will be active for 48 hours.</p>
                    </Row>
                    <Row className = "justify-content-center message__TO left">
                        <p>Tip: If you don't see the email in your inbox, check your spam folder.</p>
                    </Row>
                    <div>
                    </div>
                    </div>
                </div>
            </div>
            <div className = {` code-bottom ${this.props.activationEmailSent === true ? "block" : "none"}`} role = "complementary">
            <p className = ""><span className = "sign-in">Didn't receive an email?</span>
            <br className = "mobile-br" />
            <Link style={{"text-align": "left"}} onClick={this.props.handleEmbeddedActivation} className="bottom-link">Resend Activation Email</Link>
            </p> 
            </div>
          </div>
        )
  }
}

export default EmbeddedEmailVerificationView;